/**
 * Created by Ivan on 18.01.2023
 */
// eslint-disable-next-line no-unused-vars
const EditorFogBalloon = function (...args) {
    FogBalloon.apply(this, args);

    this.moveTo = function () {};
    this.onDragMove = function () {};
};

EditorFogBalloon.prototype = Object.create(FogBalloon.prototype);
EditorFogBalloon.prototype.constructor = EditorFogBalloon;

EditorFogBalloon.prototype.hide = function () {
};

EditorFogBalloon.prototype.canMoveTo = function (x, y) {
    let minDistanceToFogBlock = Infinity;
    const MAX_CELL_FOGBLOCK_DEVIATION = 5;

    if (cc.pointEqualToPoint(this.block.head, cc.p(x, y))) {
        return false;
    }

    this.block.tiles.forEach((tile) => {
        const tileCell = cc.p(tile.x, tile.y);
        const cell = cc.p(x, y);
        minDistanceToFogBlock = Math.min(minDistanceToFogBlock, cc.getDistanceChebyshev(cell, tileCell));
    });

    return minDistanceToFogBlock <= MAX_CELL_FOGBLOCK_DEVIATION;
};

EditorFogBalloon.prototype.setPosition = function (x, y) {
    Editor.currentEditor.doCommand("moveFogBalloon", {
        x, y, fogId: this.block.id
    });
};

EditorFogBalloon.prototype.getShape = function () {
    return FamiliesHelper.ShapeCell;
};
